export function a11yProps(index: number) {
  return {
    id: `adGroup-selection-tab-${index}`,
    "aria-controls": `adGroup-selection-tabpanel-${index}`,
  };
}
